import InputItemList from '@shared/components/core/field/list/TextInputList';
import { useTranslation } from 'react-i18next';

interface IClientTokeRedirectEditorProps {
    value: string[];
    onUpdate: (field: 'tokenAdditionalRedirectUris', value: string[]) => void;
}

export default function ClientTokeRedirectEditor({ value, onUpdate }: IClientTokeRedirectEditorProps) {
    const { t } = useTranslation();

    return (
        <InputItemList
            initialValues={value}
            legend={t('common:organization.projects.tokenRedirect.title')}
            description={t('common:organization.projects.tokenRedirect.description')}
            onChange={(updatedUris) => onUpdate('tokenAdditionalRedirectUris', updatedUris)}
        />
    );
}
